import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setLanguage, selectUserLanguage } from "../../features/user/userSlice";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/images/logo-horizontal.png";
import Languaje from "../../assets/icons/language.svg";
import menuHamburguesa from "../../assets/icons/hamurguesa.svg";
import "./header.css";

const Header = ({ texts, showMenu, setShowMenu, inLandingPage = true }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [optionsLanguage, setOptionsLanguage] = useState(false);
  const currentLanguage = useSelector(selectUserLanguage) || "es";

  const handleLanguageSelect = (language) => {
    dispatch(setLanguage(language));
    setOptionsLanguage(false);
  };

  const handleNavigation = (path) => {
    navigate(path);
  };

  const scrollToSection = (id) => {
    if (!inLandingPage) {
      handleNavigation("/");
      setTimeout(() => {
        const section = document.getElementById(id);
        section?.scrollIntoView({ behavior: "smooth" });
      }, 500);
    } else {
      const section = document.getElementById(id);
      section?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <header className="landing">
      <div className="title-landing">
        <img src={logo} alt="amvi" onClick={() => scrollToSection("main")} />
        <div className="menu-header-landing">
          <span onClick={() => scrollToSection("beneficios")}>
            {texts.header.beneficios}
          </span>
          <span onClick={() => scrollToSection("incentivos")}>
            {texts.header.incentivos}
          </span>
          <span onClick={() => scrollToSection("planes")}>
            {texts.header.planes}
          </span>
          <span onClick={() => scrollToSection("aplicaion")}>
            {texts.header.aplicacion}
          </span>
          <span onClick={() => handleNavigation("/roadmap")}>
            {texts.header.roadmap}
          </span>
          <span onClick={() => handleNavigation("/blog")}>Blog</span>
          <span onClick={() => handleNavigation("/contact")}>
            {texts.header.contact}
          </span>
        </div>
        <div className="buttons-header-landing">
          <div
            className="language-container"
            onClick={() => setOptionsLanguage(!optionsLanguage)}
          >
            <img src={Languaje} alt="" />
            <span>{(currentLanguage || "es").toUpperCase()}</span>
            {optionsLanguage && (
              <div className="tooltip">
                <div className="content">
                  <p onClick={() => handleLanguageSelect("en")}>🇺🇸 EN</p>
                  <p onClick={() => handleLanguageSelect("es")}>🇪🇸 ES</p>
                  <p onClick={() => handleLanguageSelect("de")}>🇩🇪 DE</p>
                </div>
              </div>
            )}
          </div>
          <button onClick={() => handleNavigation("/login")}>
            {texts.header.login}
          </button>
          <button onClick={() => handleNavigation("/sign-up")}>
            {texts.header.signup}
          </button>
          <img
            src={menuHamburguesa}
            alt="menu-menuHamburguesa"
            className="menu-hamburguesa"
            onClick={() => setShowMenu(!showMenu)}
          />
        </div>
      </div>
    </header>
  );
};

export default Header;
